// import yengin from 'yengin';

function Tileset(url) {
    console.warn('TODO Magma', url);
    // let self = {},
    //     priv = {};

    // /* Constructor */

    // priv.init = function (url) {
    //     priv._loaded = false;
    //     priv._url = url || '';
    //     priv._listen = [];
    //     /* Load the image */
    //     priv._img = new Image();
    //     priv._img.src = priv._url;
    //     priv._img.addEventListener('load', function () {
    //         yengin.each(priv._listen, function (callback) {
    //             callback(priv._img);
    //         });
    //         priv._loaded = true;
    //     });
    //     priv._img.addEventListener('error', function () {
    //         yengin.each(priv._listen, function (callback) {
    //             callback(priv._img);
    //         });
    //         priv._loaded = true;
    //         priv._img = null;
    //     });
    // };

    // /* Getter */

    // self.get = function (callback) {
    //     if (callback) {
    //         if (priv._loaded) {
    //             callback(priv._img);
    //         } else {
    //             priv._listen.push(callback);
    //         }
    //     }
    //     return priv._img;
    // };

    // /* Signature */
    // self.constructor = { name: 'Magma.Tileset' };
    // return priv.init(url), self;
}

export default Tileset;
